import { useState, useEffect } from 'react'
import { useMutation } from "@tanstack/react-query"

import { showLoading } from 'services/util'

import { graphql } from '../api'
import { deleteAuctionItemMutation } from '../graphql/Mutations'

import redDelete from './images/trash-icon-red.svg'
import grayDelete from './images/trash-icon-gray.svg'

import css from './sass/delete.module.scss'
import adminItemCss from './sass/adminitem.module.scss'
import themeCss from '../components/sass/theme.module.scss'

export default function ItemDeleteButton({ item, refreshAdminAuctionQuery, style }) {
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const hasBids = Number(item?.BidCount) > 0
  const deleteButtonLabel = hasBids ? 'You cannot delete an item with a bid' : 'Delete'

  const {data: deleteItemResponse, error, isPending, mutate: deleteItem } = useMutation({
    mutationFn: (input) => {
      return graphql({query: deleteAuctionItemMutation, variables: {itemId: input} })
    },
  })

  useEffect(() => {
    showLoading(isPending)

    if (error) {
      console.log("Item not deleted: ", error)
      console.log(error.errors[0].message) // errors from Appsync take this format, there may be other formats depending on where the operation fails
    }
    else if (deleteItemResponse) {
      console.log(deleteItemResponse)
      console.log('Item deleted: ', deleteItemResponse.data.deleteAuctionItem.ItemId)
      refreshAdminAuctionQuery()
      showDeleteAuctionModal()
    }
  }, [deleteItemResponse, error, isPending])

  const showDeleteAuctionModal = () => {
    let newValue = !showDeleteModal
    setShowDeleteModal(newValue)
  }
  
  let buttonClass = `${themeCss['FilledYellow']} ${themeCss['button']}`

  if (style === 'text') buttonClass = `${css['delete-button-text']}`
  if (hasBids) buttonClass = `${buttonClass} ${css['delete-button-disabled']}`
  
  return (
    <>
      <button title={deleteButtonLabel} aria-label={deleteButtonLabel} className={buttonClass} disabled={hasBids} onClick={()=> showDeleteAuctionModal()}>
        <img className={adminItemCss['admin-item-action-icons']} src={hasBids ? grayDelete : redDelete} alt=""/>
      </button>

      {showDeleteModal && !hasBids &&
        <>
          <div className={themeCss['modal-background']} onClick={()=>showDeleteAuctionModal()}> </div>
            <div className={css['delete-modal']}>
              <button className={`${themeCss['button']} ${themeCss['FilledBlue']} ${themeCss['centered-button']}`} onClick={()=>showDeleteAuctionModal()} >Close Modal</button>

              <p className={css['delete-item-header']}>
                Are you sure you want to delete <b>{item.Title}</b>?
              </p>
                
              <button className={`${themeCss['FilledYellow']} ${themeCss['button']} ${themeCss['centered-button']}`}
                onClick={()=> deleteItem(item.ItemId)}>Confirm Delete</button>
            </div>
        </>
      }
    </>
  )
}
